export default "__VITE_PUBLIC_ASSET__fee6f377__"